import React from 'react';

export default props => {
  return <span>version 1.0.0</span>;
};
